import { ComponentProps } from "react";
import Card from "@particles/card/Card";
import { useListingLoadMoreStories } from "@particles/listing/hooks/useListingLoadMoreStories";
import NewsletterPost from "@routes/Newsletter/Archive/components/NewsletterPost";
import { getNewsletterArchiveArticleCardsProps } from "@routes/Newsletter/Archive/utils/helpers";
import { getEnvironment, STORIES_PAGE_SIZE } from "@util/constant";
import { getEnvironmentDomain } from "@util/helpers";

export type NewsletterArchiveArticlesListProps = {
  articles: ComponentProps<typeof Card>[];
  keywordUrl: string;
};
const domain = getEnvironmentDomain(getEnvironment());

const NewsletterArchiveArticlesList = ({
  articles = [],
  keywordUrl,
}: NewsletterArchiveArticlesListProps): React.ReactElement => {
  const urlPath = domain + keywordUrl;

  const { loadMoreData, handleLoadMore, clickableHandleLoadMore } =
    useListingLoadMoreStories({
      templateProps: getNewsletterArchiveArticleCardsProps,
      initialList: articles,
      urlPath: urlPath,
      pageType: "keyword",
      size: STORIES_PAGE_SIZE,
    });

  const handleOnClickLoadMore = () => {
    handleLoadMore(articles);
  };

  const articleList = [...articles, ...loadMoreData];

  return (
    <div className="flex flex-wrap border-t-2 border-gray-850">
      <div className="hidden w-full lg:block lg:w-1/6">
        <h2 className="pt-4 font-poppins text-xl font-semibold">PAST ISSUES</h2>
      </div>

      <div className="flex w-full flex-row items-center justify-between pt-4 lg:hidden">
        <h2 className="font-poppins text-xl font-semibold">PAST ISSUES</h2>

        <span className="relative pl-4 text-base leading-[.3] text-orange-300 before:content-['\25CF']">
          <span className="pl-1 font-public-sans text-4xs font-normal uppercase text-gray-500">
            Subscribers
          </span>
        </span>
      </div>

      <div className="w-full pb-20 pt-4 lg:w-5/6 lg:pb-24">
        {articleList.map((article, index) => (
          <NewsletterPost
            className={
              index !== articleList.length - 1
                ? "mb-2 border-b-2 border-gray-250 pt-2"
                : ""
            }
            key={article.title}
            {...article}
          />
        ))}

        {clickableHandleLoadMore ? (
          <button
            className="my-4 w-full cursor-pointer border-y !border-gray-250 py-4 text-center font-poppins font-semibold hover:bg-gray-250"
            onClick={handleOnClickLoadMore}
          >
            SHOW MORE
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default NewsletterArchiveArticlesList;
